import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import hosting1 from '../../assets/img/hosting-1.svg';
import hosting2 from '../../assets/img/hosting-2.svg';
import hosting3 from '../../assets/img/hosting-3.svg';
import reseller1 from '../../assets/img/reseller-1.svg';
import reseller2 from '../../assets/img/reseller-2.svg';
import reseller3 from '../../assets/img/reseller-3.svg';
import './hostingWidget.scss';

function HostingWidget({ dataType }) {
    const { t } = useTranslation();

    let hostingData = [
        {
            title: t('web-hosting-page.hosting-column.title-1'),
            text: t('web-hosting-page.hosting-column.text-1'),
            image: hosting1
        },
        {
            title: t('web-hosting-page.hosting-column.title-2'),
            text: t('web-hosting-page.hosting-column.text-2'),
            image: hosting2
        },
        {
            title: t('web-hosting-page.hosting-column.title-3'),
            text: t('web-hosting-page.hosting-column.text-3'),
            image: hosting3
        }
    ];

    const resellerData = [
        {
            title: t('reseller-hosting-page.hosting-column.title-1'),
            text: t('reseller-hosting-page.hosting-column.text-1'),
            image: reseller1
        },
        {
            title: t('reseller-hosting-page.hosting-column.title-2'),
            text: t('reseller-hosting-page.hosting-column.text-2'),
            image: reseller2
        },
        {
            title: t('reseller-hosting-page.hosting-column.title-3'),
            text: t('reseller-hosting-page.hosting-column.text-3'),
            image: reseller3
        }
    ];

    if (dataType === 'reseller') {
        hostingData = resellerData;
    }

    const renderHostingItem = (hosting, index) => (
        <Col md={4} key={`${hosting.title}-${index}`}>
            <div className="single-hosting">
                <div className="hosting-image-wrapper">
                    <img className="hosting-image" src={hosting.image} alt={hosting.title} />
                </div>
                <h3 className="hosting-title">{hosting.title}</h3>
                <div className="hosting-text-wrapper">
                    <p className="hosting-text">{hosting.text}</p>
                </div>
            </div>
        </Col>
    );

    return (
        <div className="hosting-columns-wrapper">
            <Row>{hostingData.map(renderHostingItem)}</Row>
        </div>
    );
}

HostingWidget.propTypes = {
    dataType: PropTypes.string
};

HostingWidget.defaultProps = {
    dataType: 'web'
};

export default HostingWidget;
